import { ImageInterface } from '../../..';

export class ImageDto implements ImageInterface {
  title?: string;
  url: string;
  alt?: string;
  deleted?: boolean;
}
